// HOME PAGE
// export const BannerImage = [
//   {
//     id: 1,
//     name: 'Peaceful Journey',
//     image: require('./globalimages/peacefulJourney.jpg')  ,
//   },
// ];
// Nature
export const NatureImages = [
  {
    id: 1,
    name: 'Sunrise at Drummoyne Bay',
    size: '35cm(W) x 28cm(H)',
    image: require('./nature/Sunrise at Drummoyne Bay Walk.jpg')  ,
  },
  {
    id: 2,
    name: 'Ocean Waves in Jervis Bay',
    size: '91cm(W) x 76cm(H)',
    image: require('./nature/OceanWavesinJervisBay.jpg')  ,
  },
  {
    id: 3,
    name: 'Dreaming of Greece',
    size: '50cm(W) x 50cm(H)',
    image: require('./nature/DreamingofGreece.jpg')  ,
  },
  {
    id: 4,
    name: 'Blackheath Views',
    size: '92cm(W) x 60cm(H)',
    image: require('./nature/Blackheathview.jpg')  ,
  },
  {
    id: 5,
    name: 'Finding Peace Walking in Forest',
    size: '41cm(W) x 29cm(H)',
    image: require('./nature/FindingPeaceWalkinginForest.jpg')  ,
  },
  {
    id: 6,
    name: 'Wisteria Blooms',
    size: '76cm(W) x 60cm(H)',
    image: require('./nature/wisteriablooms.jpg')  ,
  },
  {
    id: 7,
    name: 'Lighthouse in Wollongong',
    size: '40cm(W) x 51cm(H)',
    image: require('./nature/LighthouseWollongong.jpg')  ,
  },
    
   
    {
      id: 8,
      name: 'Caves beach',
      size: '75cm(W) x 50cm(H)',
      image: require('./nature/cavesbeach.jpg')  ,
    },
  
    {
      id: 9,
      name: 'Minnamurra Falls',
      size: '23cm(W) x 30cm(H)',
      image: require('./nature/minnamurrafalls.jpg')  ,
    },
    {
      id: 10,
      name: 'Glistening Waters',
      size: '30.5cm(W) x 23cm(H)',
      image: require('./nature/glisteningwaters.jpg')  ,
    },
  
    {
      id: 11,
      name: 'Scenic Waters Hawaii',
      size: '30cm(W) x 30cm(H)',
      image: require('./nature/scenicwatershawaii.jpg')  ,
    },
    {
      id: 12,
      name: 'Shining Gum Tree',
      size: '40cm(W) x 30cm(H)',
      image: require('./nature/shininggumtree.jpg')  ,
    },
    {
      id: 13,
      name: 'The Lighthouse Wollongong',
      size: '18cm(W) x 13cm(H)',
      image: require('./nature/thelighthousewollongong.jpeg')  ,
    },
    {
      id: 14,
      name: 'Serene Waters',
      size: '120cm(W) x 90cm(H)',
      image: require('./nature/serenewaters.jpg')  ,
    },
    {
      id: 15,
      name: 'Beside Still Waters',
      size: '50cm(W) x 40cm(H)',
      image: require('./nature/besidestillwaters.jpg')  ,
    },
    {
      id: 16,
      name: 'Blackheath Views',
      size: '92cm(W) x 60cm(H)',
      image: require('./nature/Blackheathview.jpg')  ,
    },
  ];
  // Floral
  export const FloralImages = [
     {
      id: 1,
      name: 'Floral Bouquet',
      size: '50cm(W) x 50cm(H)',
      image: require('./floral/FloralBouquet.jpg')  ,
    },
    {
      id: 2,
      name: 'Lillies and Chrysanthemums in Vase',
      size: '60cm(W) x 60cm(H)',
      image: require('./floral/LilliesandChrysanthemumsinVase.jpg')  ,
    },
    {
      id: 3,
      name: 'Chrysanthemum Bouquet',
      size: '30cm(W) x 40cm(H)',
      image: require('./floral/chrysanthemumBouquet.jpg')  ,
    },
    {
      id: 4,
      name: 'Pretty Peony With Bumblebee',
      size: '50cm(W) x 40cm(H)',
      image: require('./floral/Pretty Peony With Bumblebee.jpg')  ,
    },
    {
      id: 5,
      name: 'Mums Hydrangeas In Vase',
      size: '50cm(W) x 50cm(H)',
      image: require('./floral/hydrangeas.jpg')  ,
    },
    {
      id: 6,
      name: 'Waterlily Study By Mason',
      size: '50cm(W) x 40cm(H)',
      image: require('./floral/waterlilystudybymason.jpg')  ,
    },
   
  
    {
      id: 7,
      name: 'Love Blossoms',
      size: '90cm(W) x 76cm(H)',
      image: require('./floral/loveblossoms.jpg')  ,
    },
    {
      id: 8,
      name: 'Minor bird in Waratah Garden',
      size: '20cm(W) x 25cm(H)',
      image: require('./floral/minorbirdinwaratahgarden.jpg')  ,
    },
    {
      id: 9,
      name: 'Skoulariki Fuschia Plant',
      size: '32cm(W) x 27cm(H)',
      image: require('./floral/skoularikifuschiaplant.jpg')  ,
    },
  
    {
      id: 10,
      name: 'Blossomed Tulip',
      size: '50cm(W) x 50cm(H)',
      image: require('./floral/blossomedtulip.jpg')  ,
    },
    {
      id: 11,
      name: 'Camden Spring Art 1',
      image: require('./floral/CamdenSpringArt1.jpg')  ,
    },
    {
      id: 12,
      name: 'Camden Spring Art 2',
      image: require('./floral/CamdenSpringArt2.jpg')  ,
    },
  ];
  
  // wildlife
  export const WildLifeImages = [
    {
      id: 1,
      name: 'Sunny The Budgie',
      size: '12.5cm(W) x 12.5cm(H)',
      image: require('./wildlife/SunnyTheBudgie.jpg')  ,
    },
    {
      id: 2,
      name: 'Turtles Swimming In Deep Blue Coral Bay',
      size: '45cm(W) x 91cm(H)',
      image: require('./wildlife/Turtles Swimming In Deep Blue Coral Bay.jpg')  ,
    },
    {
      id: 3,
      name: 'Splendid Male Blue Wren in Bush',
      size: '50cm(W) x 40cm(H)',
      image: require('./wildlife/Splendid male Blue wren in bush.jpg')  ,
    },
    {
      id: 4,
      name: 'King Lion',
      size: '40.5cm(W) x 50cm(H)',
      image: require('./wildlife/kingLion.jpg')  ,
    },
    {
      id: 5,
      name: 'Fearsome Warrior',
      size: '50cm(W) x 50cm(H)',
      image: require('./wildlife/fearsomeWarrior.jpg')  ,
    },
    {
      id: 6,
      name: 'Major Mitchell Cockatoo',
      size: '40cm(W) x 50cm(H)',
      image: require('./wildlife/majorMitchellCockatoo.jpg')  ,
    },
    
    {
      id: 7,
      name: 'Kookaburra Study by Bishal',
      size: '40cm(W) x 50cm(H)',
      image: require('./wildlife/kookaburrastudybybishal.jpg')  ,
    },
    {
      id: 8,
      name: 'Lorikeets in Love',
      size: '15cm(W) x 15cm(H)',
      image: require('./wildlife/lorikeetsinlove.jpg')  ,
    },
  
    {
      id: 9,
      name: 'Sulfar Crested Cockatoo in Fruit Tree',
      size: '76cm(W) x 51cm(H)x3.5cm(D)',
      image: require('./wildlife/sulfarcrestedcockatooinfruittree.jpg')  ,
    },
    {
      id: 10,
      name: 'Green Parrot in Tree',
      size: '31cm(W) x 39cm(H)',
      image: require('./wildlife/greenparrotintree.jpg')  ,
    },
  
    {
      id: 11,
      name: 'Silver-Gull by the Beach',
      size: '30cm(W) x 30cm(H)',
      image: require('./wildlife/silvergullbythebeach.jpg')  ,
    },
    {
      id: 12,
      name: 'Majesty',
      size: '31cm(W) x 41cm(H)',
      image: require('./wildlife/majesty.jpg')  ,
    },
    {
      id: 13,
      name: 'Baby Blue Sea Turtle',
      size: '30cm(W) x 30cm(H)',
      image: require('./wildlife/babyblueseaturtle.jpg')  ,
    },
  ];
  
  // mastercopies
  export const MastercopiesImages = [
    {
      id: 1,
      name: 'Long Awaited Kiss After Marry Cassatt',
      size: '',
      image: require('./mastercopies/Long Awaited Kiss After Mary Cassatt.jpg')  ,
    },
    {
      id: 2,
      name: 'Young woman by a window - Berthe Moriset',
      size: '',
      image: require('./mastercopies/youngwomanbyawindow.jpg')  ,
    },
  
    {
      id: 3,
      name: 'Play in the Surf - Edward Potthast',
      size: '',
      image: require('./mastercopies/playinthesurf.jpg')  ,
    },
  
    {
      id: 4,
      name: 'The Grand Canal of Venice - Edouard Manet',
      size: '',
      image: require('./mastercopies/thegrandcanalofvenice.jpg')  ,
    },
    {
      id: 5,
      name: 'Girl in Pink Dress - Michael Peter Ancher',
      size: '',
      image: require('./mastercopies/girlinpinkdress.jpg')  ,
    },
    {
      id: 6,
      name: 'Rembrandt Study',
      // size: "31cm(W)x41cm(H)",
      size: '',
      image: require('./mastercopies/rembrandtstudy.jpg')  ,
    },
  ];
  
  // potraits
  export const PortraitImages = [
    {
      id: 1,
      name: 'Walking Beside Me',
      size: '60cm(W) X 80cm(H)',
      image: require('./portrait/walkingBesideMe.jpg')  ,
    },
 
    {
      id: 2,
      name: 'Martin Luther King',
      size: '',
      image: require('./portrait/martinlutherking.jpg')  ,
    },
    {
      id: 3,
      name: 'Portrait 1',
      size: '',
      image: require('./portrait/Effie.jpg')  ,
    },
    {
      id: 4,
      name: 'Portrait 2',
      size: '',
      image: require('./portrait/portrait1.jpg')  ,
    },
  
    {
      id: 5,
      name: 'Portrait 2',
      size: '',
      image: require('./portrait/portrait2.jpg')  ,
    },
    {
      id: 6,
      name: 'Christopher',
      size: '',
      image: require('./portrait/christopher.jpg')  ,
    },
  ];
  
  // pet portraits paintings
  export const PetportraitsImages = [
    {
      id: 1,
      name: 'Buggy Rabbits',
      size: '',
      image: require('./petportraits/BuggyRabbits.jpg')  ,
    },
   
    {
      id: 2,
      name: 'Cute Cat',
      size: '',
      image: require('./petportraits/princess.jpg')  ,
    },
   
    {
      id: 3,
      name: 'Yogi with Big Red Bow',
      size: '',
      image: require('./petportraits/Yogi the Cavoodle With Big Red Bow.jpg')  ,
    },
    {
      id: 4,
      name: 'Princess the Cat',
      size: '',
      image: require('./petportraits/princessthecat.jpg')  ,
    },
    {
      id: 5,
      name: 'Striking Macaws',
      size: '',
      image: require('./petportraits/strikingmacaws.jpg')  ,
    },
    {
      id: 6,
      name: 'Charlie',
      size: '',
      image: require('./petportraits/charlie.jpg')  ,
    },
    {
      id: 7,
      name: 'Lorikeet',
      size: '',
      image: require('./petportraits/lorikeet.jpg')  ,
    },
  ];
  // sold
  export const SoldImages = [
    {
      id: 1,
      name: 'BuggyRabits',
      size: '50cm(W) x 50cm(H)',
      image: require('./sold/BuggyRabits.jpg')  ,
    },
    {
      id: 2,
      name: 'sydneyHarbourBridge',
      size: '125cm(W) x 65cm(H)',
      image: require('./sold/sydneyHarbourBridge.jpg')  ,
    },
    {
      id: 3,
      name: 'Blue and Gold Macaw',
      size: '40cm(W) x 50cm(H)',
      image: require('./sold/blueandgoldmacaw.jpg')  ,
    },
    {
      id: 4,
      name: 'Lifes Sweet Perfume',
      size: '60cm(W) x 30cm(H)',
      image: require('./floral/lifessweetperfume.jpg')  ,
    },
    {
      id: 5,
      name: "Nature's Beauty",
      size: '40cm(W) x 50cm(H)',
      image: require('./sold/naturebeauty.jpg')  ,
    },
    {
      id: 6,
      name: 'Deer in Wilderness',
      size: '25cm(W) x 30cm(H)',
      image: require('./sold/deerinwilderness.jpg')  ,
    },
    {
      id: 7,
      name: 'Hang-in-there Koala Bear',
      size: '  20cm(W) x 25cm(H) ',
      image: require('./sold/hangintherekoalabear.jpg')  ,
    },
    {
      id: 8,
      name: 'Aussie Lorikeet',
      size: '25cm(W) x 30cm(H) ',
      image: require('./sold/aussielorikeet.jpg')  ,
    },
    {
      id: 9,
      name: 'Calming Florals(Commission Piece)',
      size: '76cm(W) x 76cm(H)  ',
      image: require('./sold/calmingflorals.jpg')  ,
    },
    {
      id: 10,
      name: 'Budgies in Love',
      size: '30cm(W) x 30cm(H)  ',
      image: require('./sold/budgiesinlove.jpg')  ,
    },
    {
      id: 11,
      name: 'Deep Blue Sea Turtle',
      size: '45cm(W) x 60cm(H)  ',
      image: require('./sold/deepblueseaturtle.jpg')  ,
    },
    {
      id: 12,
      name: 'Peaceful Journey(Commission Piece)',
      size: '90cm(W) x 120cm(H)  ',
      image: require('./sold/peacefuljourney.jpg')  ,
    },
    {
      id: 13,
      name: 'On The Road to Minnamurra Falls',
      size: '11cm(W) x 18cm(H)  ',
      image: require('./sold/ontheroadtominnamurrafalls.jpg')  ,
    },
  ];
  
  

  export const CommissionSamples = [
    {
      id: 1,
      name: 'Calming Florals 2020',
      size: '76cm x 76cm x 4cm depth',
      info: 'Oil on stretched canvas',
      image: require(`./sold/calmingflorals.jpg`),
      clName: 'cactive',
    },
    {
      id: 2,
      name: 'Martin Luther King',
      size: '',
      info: '',
      image: require('./portrait/martinlutherking.jpg'),
      clName: 'cactive',
    },
    {
      id: 3,
      name: 'Peaceful Journey 2021',
      size: '120cm x 90cm x 4cm depth',
      info: 'Oil on stretched canvas',
      image: require('./sold/peacefuljourney.jpg'),
      clName: 'cactive',
    },
    {
      id: 4,
      name: 'Charlie',
      size: '',
      info: '',
      image: require('./petportraits/charlie.jpg'),
      clName: 'cactive',
    },
  ];
  
  // more paintings
  export const MorePaintingImages = [
    {
      id: 1,
      name: 'Great Ocean Road',
      size: 'none',
      image: require('./morepaintings/greatoceanroad.jpg'),
    },
    {
      id: 2,
      name: 'The Three Sisters',
      size: 'none',
      image: require('./morepaintings/threesisters.jpg'),
    },
  ];
  
  export const blueThumb = (
    <div className="bluethum-badge">
      <a href="https://bluethumb.com.au/stella-kypriotis">
        <img
          src="https://bluethumb.com.au/integrations/badge/for-sale/outline-blue.png?destination_id=my_artist_profile&fbclid=IwAR1x91rquyySqIXg33D2cTj9uIPXXUM4BE9LFwO4wnekR3NdNyHUbceF7L4"
          alt=""
          width="135"
          height="60"
        />
      </a>
    </div>
  );


  // Wall display 


  export const initialGalleryItems = [
    

    
    
    { id: 1, category: 'Portraits', frontImage: require('./portrait/martinlutherking.jpg'), backImage: require('./wallDisplayImages/martinlutherkingonwall.jpg'), flipped: false },
    { id: 2, category: 'Wildlife', frontImage: require('./wildlife/kookaburrastudybybishal.jpg'), backImage: require('./wallDisplayImages/KookaburraStudyByBishalonwall.jpg'), flipped: false },
    { id: 3, category: 'Nature', frontImage: require('./nature/OceanWavesinJervisBay.jpg'), backImage: require('./wallDisplayImages/OceanWavesInJervisBayonwall.jpg'), flipped: false },
    { id: 4, category: 'Wildlife', frontImage: require('./wildlife/kingLion.jpg'), backImage: require('./wallDisplayImages/KingLiononwall.jpg'), flipped: false },
    { id: 5, category: 'Portraits', frontImage: require('./portrait/Effie.jpg'), backImage: require('./wallDisplayImages/portrait1onwall.jpg'), flipped: false },
    { id: 6, category: 'Wildlife', frontImage: require('./wildlife/fearsomeWarrior.jpg'), backImage: require('./wallDisplayImages/fearsomewarrioronwall.jpg'), flipped: false },
    { id: 7, category: 'Nature', frontImage: require('./nature/wisteriablooms.jpg'), backImage: require('./wallDisplayImages/wisteriabloomsonwall.jpg'), flipped: false },
    { id: 8, category: 'Nature', frontImage: require('./nature/FindingPeaceWalkinginForest.jpg'), backImage: require('./wallDisplayImages/findingpeacewalkinginforestonwall.jpg'), flipped: false },
    // { id: 9, category: 'Portraits', frontImage: require('./portrait/christopher.jpg'), backImage: require('./portrait/christopher.jpg'), flipped: false },
  
    // Add more items as needed

  ];

  export const DisplayOnTheWall = [
  {
      id: 0,
      name: 'Ocean Waves in Jervis Bay',
    size: '91cm(W) x 76cm(H)',
    image: require('./nature/OceanWavesinJervisBay.jpg')  ,
      wallImg: require('./wallDisplayImages/OceanWavesInJervisBayonwall.jpg')
    },
  
    {
      id: 1,
      name: 'King Lion',
      size: '40.5cm(W) x 50cm(H)',
      image: require('./wildlife/kingLion.jpg')  ,
      wallImg: require('./wallDisplayImages/KingLiononwall.jpg')  
    },

    {
      id: 2,
      name: 'Kookaburra Study by Bishal',
      size: '40cm(W) x 50cm(H)',
      image: require('./wildlife/kookaburrastudybybishal.jpg')  ,
      wallImg: require('./wallDisplayImages/KookaburraStudyByBishalonwall.jpg')
    
     
    },
   
  ];


  